import { render } from "./GridViewer.vue?vue&type=template&id=451d1c2d&scoped=true"
import script from "./GridViewer.vue?vue&type=script&lang=js"
export * from "./GridViewer.vue?vue&type=script&lang=js"

import "./GridViewer.vue?vue&type=style&index=0&id=451d1c2d&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451d1c2d"]])

export default __exports__